import { api } from "./config";

export async function GetUsersList(search = "") {
  try {
    const response = await api().get("/user/list", {
      params: {
        search,
      },
    });
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function StoreUser(
  name,
  email,
  password,
  whatsapp,
  role,
  stations,
  remark,
  whatsappInstances,
  agentId,
  allowedSeeAllCustomers,
  allowedSeeAllPackages
) {
  try {
    const response = await api().post("/user/store", {
      name,
      email,
      password,
      whatsapp,
      role,
      stations,
      remark,
      whatsappInstances,
      agentId,
      allowedSeeAllCustomers,
      allowedSeeAllPackages,
    });
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function PatchUser(
  _id,
  name,
  email,
  whatsapp,
  role = "user",
  stations,
  remark,
  validflag,
  whatsappInstances,
  whatsappChatFooter, // admin-only on the backend; undefined = leave unchanged
  agentId,
  allowedSeeAllCustomers, // undefined = leave unchanged
  allowedSeeAllPackages
) {
  try {
    const response = await api().patch("/user/patch", {
      _id,
      name,
      email,
      whatsapp,
      role,
      stations,
      remark,
      validflag,
      whatsappInstances,
      whatsappChatFooter,
      agentId,
      allowedSeeAllCustomers,
      allowedSeeAllPackages,
    });
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function PatchUserPassword(_id, password) {
  try {
    const response = await api().patch("/user/patch", {
      _id,
      password,
    });
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetUserDetail(userId) {
  try {
    const response = await api().get("/user/" + userId);
    
    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}
